<template>
<!-- SORT : START -->
<div class="col-12">
	<div class="form-group">
		<b-dropdown text="Sort by" :disabled = "false" >
			<b-dropdown-item
			@click = "handleSort('Name', 'ASC')"

			>Name ASC</b-dropdown-item>
			<b-dropdown-item
			@click = "handleSort('Name', 'DESC')"
			>Name DESC</b-dropdown-item> 

			<b-dropdown-divider></b-dropdown-divider>

			<b-dropdown-item 
			@click = "handleSort('Level', 'ASC')"
			>Level ASC</b-dropdown-item>

			<b-dropdown-item
			@click = "handleSort('Level', 'DESC')"
			 >Level DESC</b-dropdown-item>
		</b-dropdown>
		<span class="badge badge-success badge-medium">{{sortBy}} - {{sortWay}}</span>
	</div>
</div>
<!-- SORT : END -->
</template>
<script type="text/javascript">
	export default {
		name: "component-search-sort",
		props:{
			sortBy: {type: String, default: "Level"},
			sortWay: {type: String, default: "ASC"},
		},
		data: function(){
			return {

			}
		},

		methods: {
			handleSort(sortBy, sortWay){
				console.log(sortBy + " và " + sortWay);
				this.$emit("handleSortControl", sortBy, sortWay);				
			}
		}

	}
</script>
<style type="text/css">
	
	.badge-success {
    /* font-size: 24px; */
    box-shadow: rgba(101, 41, 255, 0.15) 0px 10px 20px;
    color: white;
    font-weight: 600;
    /* cursor: pointer; */
    display: inline-block;
    justify-self: center;
    white-space: nowrap;
    background: linear-gradient(104.74deg, rgb(123, 66, 246) 0%, rgb(176, 30, 255) 100%);
    /* border-radius: 30px; */
    border-width: initial;
    border-style: none;
    border-color: initial;
    border-image: initial;
    /* padding: 16px 60px; */
    outline: none;
    transition: all 0.8s cubic-bezier(0.2, 0.8, 0.2, 1.2) 0s;
}

span.badge.badge-success.badge-medium {
    border-radius: 0 10px 0 10px;
}


</style>